import { ArrowUpRight } from 'lucide-react'

import { Reveal } from './Reveal'

export function ResourceCard({ item, index }) {
  const Icon = item.icon

  return (
    <Reveal delay={index * 0.08}>
      <article className="resource-card">
        <div className="flex items-start justify-between gap-4">
          <span className="resource-card-icon">
            <Icon aria-hidden="true" size={26} strokeWidth={1.8} />
          </span>
          <ArrowUpRight aria-hidden="true" size={26} strokeWidth={1.7} />
        </div>
        <div>
          <p className="mb-3 text-xs font-extrabold tracking-[0.12em] uppercase opacity-60">
            {item.tag}
          </p>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </div>
      </article>
    </Reveal>
  )
}
